import axios from "axios";

type EventFilters = {
  date?: string;
  price?: string;
  category?: string;
  city?: string;
};

export default async function getEvents(filters?: EventFilters) {
  const { data } = await axios.get(
    `${process.env.NEXT_PUBLIC_API_URL}events`,
    {
      params: {
        date: filters?.date,
        price: filters?.price,
        category: filters?.category,
        city: filters?.city,
      },
    }
  );

  if (data) {
    return data;
  } else {
    throw new Error("Failed to fetch events");
  }
}
